import React from 'react';
import Navigation from '../navigation';

const SliderContainer: React.FC = () => {
    return (
      <div className='page-layout'>
        <Navigation/>
        <main className='main'>
          <div>Select</div>
        </main>
      </div>
    );
  };
  
export default SliderContainer;